export const UPDATE_USER_MARKETS = 'UPDATE_USER_MARKETS'
export const UPDATE_USER_EXPERIENCE = 'UPDATE_USER_EXPERIENCE'
export const SET_EDIT_SAVING_STATE = 'SET_EDIT_SAVING_STATE'

export const USER_ACTIONS = {
  UPDATE_USER_FIELD: 'USER_ACTIONS.UPDATE_USER_FIELD',
}

export const FILTER_ACTIONS = {
  // INITIATE_FILTER: 'INITIATE_FILTER',
  INITIATE_JOBS_FILTER: 'FILTER_ACTIONS.INITIATE_JOBS_FILTER',
  INITIATE_PROFILES_FILTER: 'FILTER_ACTIONS.INITIATE_PROFILES_FILTER',
  UPDATE_FILTER_FROM_QUERY: 'FILTER_ACTIONS.UPDATE_FILTER_FROM_QUERY',
}

export const JOB_ACTIONS = {
  SEARCH_JOBS: 'JOB_ACTIONS.SEARCH_JOBS',
  INITIATE_JOBS: 'JOB_ACTIONS.INITIATE_JOBS',
  DISPATCH_SEARCH_JOBS: 'JOB_ACTIONS.DISPATCH_SEARCH_JOBS',
}

export const PROFILES_ACTIONS = {
  SEARCH_PROFILES: 'PROFILES_ACTIONS.SEARCH_PROFILES',
  NEXT_PAGE: 'PROFILES_ACTIONS.NEXT_PAGE',
}
